<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M42.69 20.81a2 2 0 000-3.62L24.86 8.75a2 2 0 00-1.72 0L5.31 17.19a2 2 0 000 3.62L10 23v8.41a3.45 3.45 0 00.61 2c1.25 1.83 5.07 6.09 13.39 6.09s12.14-4.26 13.4-6.09a3.52 3.52 0 00.6-2V23l2-1v12.2a2 2 0 00-1 1.8 2 2 0 004 0 2 2 0 00-1-1.72V21.13zM35 31.44a.5.5 0 01-.08.27c-1 1.44-4 4.79-10.92 4.79s-9.93-3.35-10.92-4.79a.5.5 0 01-.08-.27v-7l10.14 4.8a1.95 1.95 0 001.72 0L35 24.45zm-11-5.1L8.5 19 24 11.66 39.5 19z"/><ellipse cx="24" cy="19" rx="2" ry="1.5"/></svg>